/**
 * Frontend Routes
 * Centralized route definitions for all auth flows.
 */

export const ROUTES = {
    // Signup Routes
    SIGNUP: "/",
    SIGNUP_VERIFY_EMAIL: "/verify-email",
    SIGNUP_PROFILE: "/profile",
    SIGNUP_VERIFY_PHONE: "/verify-phone",
    SIGNUP_SET_PASSWORD: "/set-password",
    SIGNUP_MFA_SETUP: "/mfa-setup",
    SIGNUP_MFA_SETUP_TOTP: "/mfa-setup/totp",
    SIGNUP_MFA_SETUP_WEBAUTHN: "/mfa-setup/webauthn",
    SIGNUP_BACKUP_CODES: "/backup-codes",
    SIGNUP_SUCCESS: "/success",

    // Signin Routes
    SIGNIN: "/",
    SIGNIN_PASSWORD: "/password",
    SIGNIN_MFA: "/mfa",
    SIGNIN_MFA_TOTP: "/mfa/totp",
    SIGNIN_MFA_WEBAUTHN: "/mfa/webauthn",
    SIGNIN_MFA_BACKUP: "/mfa/backup",
    SIGNIN_SSO: "/sso-redirect",
    SIGNIN_SUCCESS: "/success",
    SIGNIN_CALLBACK: "/callback", // OIDC frontend-initiated callback route
    // ... [NEW: Signin Employee Onboarding Routes] ...
    SIGNIN_FORCE_CHANGE_PASSWORD: "/force-change-password",
    SIGNIN_MFA_SETUP: "/mfa-setup", // Intro/choice screen during login
    SIGNIN_MFA_SETUP_TOTP: "/mfa-setup/totp", // QR code + TOTP verification
    SIGNIN_MFA_BACKUP_SETUP: "/mfa-setup/backup-codes", // NEW

    // Account Recovery Routes (Advanced Flow)
    ACCOUNT_RECOVERY: "/",
    RECOVERY_FIND_ACCOUNT: "/find-account",
    RECOVERY_METHODS: "/methods",
    RECOVERY_VERIFY_IDENTITY: "/verify-identity",
    RECOVERY_VERIFY_IDENTITY_OTP: "/verify-identity-otp", // ADDED
    RECOVERY_VERIFY_AUTHORITY: "/verify-authority",
    RECOVERY_RESET_PASSWORD: "/reset-password",
    RECOVERY_SUCCESS: "/success",

    // Legacy/Other Recovery Routes (Preserved for safety)
    RECOVERY_PASSWORD_REQUEST: "/password-request",
    RECOVERY_PASSWORD_RESET: "/password-reset",
    RECOVERY_PASSWORD_SUCCESS: "/password-success",
    RECOVERY_LOST_ACCESS: "/lost-access",
    RECOVERY_STATUS: "/request-status",
    RECOVERY_COMPLETE: "/complete",
    RECOVERY_TOKEN_EXPIRED: "/token-expired",

    // Common Routes (ADDED)
    NOT_FOUND: "/404",
    HOME: "/",
    DASHBOARD: "/dashboard",
} as const;

export type RouteKey = keyof typeof ROUTES;
